 <template>
  <div class="info-region-container">
    <div
      class="all-content-container"
      v-allow="'0604'"
      style="margin: 0 auto; width: 100%"
    >
      <div class="container1">
        <div class="titlemaun" style="">
          <div style="padding: 15px; border: ">
            <h3>{{ evnName }} - 环境参数</h3>
          </div>
          <div class="table-title-btn">
            <el-button type="primary" class="adduser" @click="handleAdd"
              >添加</el-button
            >
            <el-button type="primary" class="adduser" @click="handleReturn"
              >返回大棚环境模型</el-button
            >
          </div>
        </div>
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="参数类型：">
            <el-select
              v-model="searchForm.paramType"
              clearable
              placeholder="请选择参数类型"
              @change="handleSearch"
            >
              <el-option
                v-for="item in paramTypeArray"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="控制状态：">
            <el-select
              v-model="searchForm.isControl"
              clearable
              placeholder="请选择控制状态"
              @change="handleSearch"
            >
              <el-option label="已生效" value="0"></el-option>
              <el-option label="未生效" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="button" @click="handleSearch"
              >查询</el-button
            >
            <el-button type="button" ass="button" @click="handleRest"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div class="info-content-container">
        <div class="table_content1" style="margin-top: 10px">
          <el-table
            :data="tableData"
            align="center"
            class="data-table"
            v-loading="loading"
            style="width: 100%"
            :header-cell-style="{ background: '#F4F5F7' }"
          >
            <el-table-column align="center" label="参数类型">
              <template slot-scope="scope">
                <p>{{ scope.row.paramType | paramTypeName }}</p>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="阈值偏差"
              :render-header="renderHeader"
            >
              <template slot-scope="scope">
                <p>
                  {{ scope.row.param + getParamTypeUnit(scope.row.paramType) }}
                </p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="控制类型">
              <template slot-scope="scope">
                <p v-if="scope.row.controlType == 0">整体控制</p>
                <p v-if="scope.row.controlType == 1">局部控制</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="控制状态">
              <template slot-scope="scope">
                <p v-if="scope.row.isControl == 0">已生效</p>
                <p v-if="scope.row.isControl == 1">未生效</p>
              </template>
            </el-table-column>
            <el-table-column fixed="right" align="center" label="操作">
              <template slot-scope="scope">
                <el-button
                  @click="handleDevice(scope.row)"
                  type="text"
                  size="small"
                  >设备参数</el-button
                >
                <el-button
                  @click="handleControl(scope.row)"
                  type="text"
                  size="small"
                  v-if="scope.row.isControl == 1"
                  >生效</el-button
                >
                <el-button
                  @click="handleControl(scope.row)"
                  type="text"
                  size="small"
                  v-if="scope.row.isControl == 0"
                  >取消</el-button
                >
                <el-button
                  @click="handleEdit(scope.row)"
                  type="text"
                  size="small"
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="handleDel(scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-container">
          <div class="page"></div>
          <div class="pagination-content-container">
            <el-pagination
              background
              layout="prev, pager, next, jumper"
              class="pageTap"
              @current-change="handleCurrentChange"
              :current-page="searchForm.pageNum"
              :page-size="searchForm.pageSize"
              :total="total"
            ></el-pagination>
          </div>
        </div>
        <el-dialog
          :title="addEditTitle"
          :visible.sync="addEditIsDialog"
          :before-close="handleCancel"
          width="600px"
          center
          style="z-index: 10000"
        >
          <el-form
            ref="ruleForm"
            :rules="rules"
            :model="ruleForm"
            label-width="120px"
            class="demo-ruleForm"
          >
            <el-row>
              <el-col :span="24">
                <el-form-item label="参数类型：" prop="paramType">
                  <el-select
                    v-model="ruleForm.paramType"
                    placeholder="请选择参数类型"
                    clearable
                  >
                    <el-option
                      v-for="item in paramTypeArray"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="阈值偏差：" prop="param">
                  <el-input-number
                    v-model="ruleForm.param"
                    size="small"
                    :precision="2"
                    :step="1"
                    :max="99999999"
                    :min="-99999999"
                    placeholder="请输入阈值偏差"
                  ></el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="控制类型：" prop="controlType">
                  <el-select
                    v-model="ruleForm.controlType"
                    placeholder="请选择控制类型"
                    clearable
                  >
                    <el-option label="整体控制" value="0"></el-option>
                    <el-option label="局部控制" value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="handleCancel">取 消</el-button>
            <el-button type="primary" @click="handleSave">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      searchForm: {
        // 查询条件表单字段
        pageNum: 1,
        pageSize: 10,
        evnId: "",
        isControl: "",
        paramType: "",
      },
      total: 0, // 总条数
      tableData: [], // 表格数据
      loading: false, // 表格加载中是否显示
      ruleForm: {
        // 添加编辑表单字段
        id: "",
        evnId: "",
        paramType: "",
        param: "",
        controlType: "",
      },
      rules: {
        // 添加编辑表单规则
        paramType: [
          {
            required: true,
            message: "请选择参数类型",
            trigger: "change",
          },
        ],
        param: [
          {
            required: true,
            message: "请输入阈值偏差",
            trigger: "blur",
          },
        ],
        controlType: [
          {
            required: true,
            message: "请选择控制类型",
            trigger: "change",
          },
        ],
      },
      evnId: "", // 模型环境ID
      evnName: "", // 模型环境名称
      addEditTitle: "添加模型环境", // 添加编辑弹窗标题
      addEditIsDialog: false, // 添加编辑弹窗是否显示
      paramTypeArray: this.$filters.paramTypeArray(),
    };
  },
  created() {
    this.searchForm.evnId = this.$route.query.evnId;
    this.ruleForm.evnId = this.$route.query.evnId;
    this.evnId = this.$route.query.evnId;
    this.evnName = this.$route.query.evnName;

    // 查询
    this.getList();
  },
  methods: {
    // 阈值偏差自定义请求头
    renderHeader(h, { column, $index }) {
      return h("div", [
        h("span", column.label),
        h(
          "el-tooltip",
          {
            props: {
              effect: "dark",
              content:
                "以空气温度为例，棚内植物最佳生长环境空气温度为20℃~25℃，阈值偏差设置为0.5℃，当棚内空气温度低于19.5℃或高于25.5℃时，则设备会进行环境控制。",
              placement: "top",
            },
          },
          [
            h("i", {
              class: "el-icon-question",
              style: "color:#409eff;margin-left:5px;",
            }),
          ]
        ),
      ]);
    },
    // 查询
    handleSearch() {
      this.searchForm.pageNum = 1;
      this.getList();
    },
    // 重置
    handleRest() {
      this.searchForm = {
        pageNum: 1,
        pageSize: 10,
        evnId: this.evnId,
        isControl: "",
        paramType: "",
      };
      this.getList();
    },
    // 分页查询
    handleCurrentChange: function (currentPage) {
      this.searchForm.pageNum = currentPage;
      this.getList();
    },
    // 分页获取列表
    getList() {
      this.loading = true;
      this.$api.growthModel
        .getGrowthModelEvnParamList(this.searchForm)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
            this.total = res.count;
            this.loading = false;
          }
        });
    },
    // 删除
    handleDel(row) {
      this.$confirm("是否删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api.growthModel.delGrowthModelEvnParam(row.id).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: res.msg,
              });
              this.getList();
            }
          });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    // 控制
    handleControl(row) {
      this.$api.growthModel
        .openOrCloseGrowthModelEvnParam({ id: row.id })
        .then((res) => {
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: res.msg,
            });
            this.getList();
          }
        });
    },
    // 编辑
    handleEdit(row) {
      this.addEditIsDialog = true;
      this.addEditTitle = "编辑环境参数";
      this.ruleForm.id = row.id;
      this.ruleForm.evnId = this.evnId;

      // 获取详情
      this.$api.growthModel
        .getGrowthModelEvnParam({ id: row.id })
        .then((res) => {
          if (res.code == 200) {
            this.ruleForm = res.data;
            this.ruleForm.isControl = res.data.isControl.toString();
            this.ruleForm.controlType = res.data.controlType.toString();
          }
        });
    },
    // 添加
    handleAdd() {
      this.addEditIsDialog = true;
      this.addEditTitle = "添加环境参数";
      this.ruleForm.id = "";
      this.ruleForm.evnId = this.evnId;
    },
    // 取消
    handleCancel() {
      this.$refs["ruleForm"].resetFields();
      this.addEditIsDialog = false;
    },
    // 保存
    handleSave() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.$api.growthModel
            .saveGrowthModelEvnParam(this.ruleForm)
            .then((res) => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: res.msg,
                });
                this.handleCancel();
                this.handleSearch();
              }
            });
        }
      });
    },
    // 设备参数
    handleDevice(row) {
      this.$router.push({
        name: `growthModelParamDeviceManagement`,
        query: {
          paramId: row.id,
          paramType: row.paramType,
          paramName:
            this.evnName + "_" + this.$filters.paramTypeName(row.paramType),
          paramUnit: this.$filters.paramTypeUnit(row.paramType),
          evnId: this.evnId,
          evnName: this.evnName,
          groupId: this.$route.query.groupId,
          controlType: row.controlType,
        },
      });
    },
    // 获取参数单位
    getParamTypeUnit(paramType) {
      return this.$filters.paramTypeUnit(paramType);
    },
    // 返回
    handleReturn() {
      this.$router.push({
        name: `growthModel`,
        query: {
          currentShow: "second",
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container1 {
  border: 1px solid rgba(232, 232, 232, 1);
}

.el-button {
  line-height: 0;
}

.all-content-container {
  width: 100%;
}

.titlemaun {
  display: flex;
  justify-content: space-between;
  height: 48px;
  border-bottom: 1px solid #ededed;
  border-top: 1px solid #ededed;
  margin-top: 1px;
}

h4 {
  font-size: 14px;
  font-weight: 550;
  color: #000;
  height: 48px;
  line-height: 48px;
  padding-left: 18px;
}

.demo-ruleForm {
  width: 95%;
  margin: 0 auto;
  padding-top: 10px;

  .el-row {
    margin-bottom: 20px;
  }

  .el-select {
    width: 100% !important;
  }

  .el-input-number {
    width: 100% !important;
  }
}
</style>